import { useEffect, useRef, useState } from "react";
import { Button, Divider, message } from "antd";
import { ReactComponent as SendArrow } from "icons/sendArrow.svg";
import { useCurrentUserContext } from "providers";
import moment from "moment";
import { ConditionalRenderer } from "components";
import styles from "./styles.module.scss";
import { ReactComponent as AttachmentIcon } from "icons/attachmentIcon.svg";
import { issueTypeColors, issueTypeIcons } from "../constants";

export const Activity = ({
  singleTicketData,
  // totalMessages,
  setTotalMessages,
  ticketId,
}) => {
  const totalMessages = [
    {
      sender: "zohaib.ahmad@fenrispakistan.com",
      ticket_id: "m2c-112-784869",
      sent_at: "2024-07-10T13:36:40.367737+00:00",
      message_id: "m2c-57a968",
      message:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Loremipsum dolor sit amet, consecteturLorem ipsum dolor sit amet,consectetur adipiscing elit.Lorem ipsum dolor sit amet,consectetur",
      isAdmin: true,
    },
    {
      sender: "zohaib.ahmad@fenrispakistan.com",
      ticket_id: "m2c-112-784869",
      sent_at: "2024-07-10T13:38:40.367737+00:00",
      message_id: "m2c-57a969",
      message:
        "nsectetur adipiscing elit.Loremipsum dolor sit amet, consecteturLorem ipsu",
      isAdmin: false,
    },
    {
      sender: "zohaib.ahmad@fenrispakistan.com",
      ticket_id: "m2c-112-784869",
      sent_at: "2024-07-10T13:58:40.367737+00:00",
      message_id: "m2c-57a967",
      message:
        "nsectetur adipiscing elit.Loremipsum dolor sit amet, consecteturLorem ipsu",
      isAdmin: true,
    },
  ];
  const allMessages = singleTicketData?.messages;
  const [messageContent, setMessageContent] = useState("");

  const { user } = useCurrentUserContext();

  const chatSocketRef = useRef();

  const chatUrl = `${
    process.env.REACT_APP_Ticket_Chat_URL ||
    "wss://dptzlmd66d.execute-api.eu-central-1.amazonaws.com/dev/?ticket_id="
  }${ticketId}`;

  const chatContainerRef = useRef();
  const textAreaRef = useRef();

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [totalMessages]);

  function getChatSocketConnection(chatUrl) {
    const socket = new WebSocket(chatUrl);
    socket.onopen = (data) => {
      console.log("chat connection established");
    };

    socket.onmessage = (event) => {
      const message = event.data;
      const data = JSON.parse(message);
      setTotalMessages((prevMessages) => {
        return [...prevMessages, data];
      });
    };

    chatSocketRef.current = socket;
    return socket;
  }

  useEffect(() => {
    const socket = getChatSocketConnection(chatUrl);
    return () => socket.close();
  }, []);

  function handleSendMessage() {
    const messagePayload = {
      message: messageContent,
      ticket_id: ticketId,
      sender: user?.email,
    };
    chatSocketRef.current.send(JSON.stringify(messagePayload));
    setMessageContent("");
  }

  function handleChangeMessage(event) {
    const messageContent = event.target.value;
    setMessageContent(messageContent);

    // Adjust the height of the textarea
    const textArea = textAreaRef.current;
    textArea.style.height = "auto";
    textArea.style.height = textArea.scrollHeight + "px";
  }

  function handleKeyDown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      if (messageContent.trim()) {
        handleSendMessage();
      }
    }
  }

  function formatDate(inputDate) {
    const today = moment().startOf("day");
    const yesterday = moment().subtract(1, "days").startOf("day");
    const momentDate = moment(inputDate);
    const date = momentDate?.format("LL");
    if (momentDate?.isSame(today, "d")) {
      return "Today";
    } else if (momentDate?.isSame(yesterday, "d")) {
      return "Yesterday";
    }
    return date;
  }
  const Icon = issueTypeIcons["Capturing"];

  return (
    <>
      <div className={styles.activityContainer}>
        <div className={styles.messageContainer}>
          <div className={styles.header}>
            <div className={styles.issueDetail}>
              <h2>I am not able to capture the swings?</h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.Lorem
                ipsum dolor sit amet, consecteturLorem ipsum dolor sit amet,
                consectetur adipiscing elit.Lorem ipsum dolor sit amet,
                consectetur
              </p>
            </div>
            <div className={styles.issueTagAndTime}>
              <div
                className={styles.issueTag}
                style={{ backgroundColor: `${issueTypeColors["Capturing"]}` }}
              >
                <Icon />
                Capturing
              </div>
              <div className={styles.postedAt}>Posted at 12:45 AM</div>
            </div>
          </div>
          <div
            ref={chatContainerRef}
            style={{
              maxHeight: "80%",
              overflowY: "auto",
              padding: "0px 10px",
            }}
          >
            {/* <ConditionalRenderer condition={Array.isArray(allMessages)}> */}

            {totalMessages?.map((item, index) => {
              const formattedTime = moment(item?.sent_at).format("h:mm A");
              const formatDateNew = formatDate(item?.sent_at);

              let shouldHideDate = false;
              let currentIndexDate = "";
              let previousIndexDate = "";
              if (index !== 0) {
                currentIndexDate = moment(
                  totalMessages[index]["sent_at"]
                ).format("DD/MM/YY");
                previousIndexDate = moment(
                  totalMessages[index - 1]["sent_at"]
                ).format("DD/MM/YY");
                shouldHideDate = currentIndexDate === previousIndexDate;
              }

              return (
                <>
                  <ConditionalRenderer condition={!shouldHideDate}>
                    <div className={styles.date}>{formatDateNew}</div>
                  </ConditionalRenderer>
                  <div
                    className={styles[item.isAdmin ? "sentMsg" : "receivedMsg"]}
                  >
                    <div className={styles.msg}>{item.message}</div>
                    <div className={styles.time}>{formattedTime}</div>
                  </div>
                </>
              );
            })}
            {/* </ConditionalRenderer> */}
          </div>

          <div className={styles.textAreaContainer}>
            <textarea
              ref={textAreaRef}
              onKeyDown={handleKeyDown}
              placeholder="Write a message..."
              className={styles.textArea}
              onChange={handleChangeMessage}
              value={messageContent}
              rows={1}
            />
            <div className={styles.sendBtnContainer}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                {/* <AttachmentIcon /> */}

                <Button
                  className={styles.sendBtn}
                  onClick={handleSendMessage}
                  disabled={!messageContent.trim()}
                >
                  <SendArrow style={{ transform: "rotate(-40deg)" }} />
                  Send Message
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
